export default {"src":"/_next/static/media/integrate.21641e99.svg","height":65,"width":65};